import { render } from "./CardLogoAndNumbers.vue?vue&type=template&id=0cc9f043"
import script from "./CardLogoAndNumbers.vue?vue&type=script&lang=js"
export * from "./CardLogoAndNumbers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__